export enum ChannelOptions {
  MORE = 'More',
  RESERVATION = 'Reservation messages',
  REPORT_ISSUE = 'Report issue messages',
  RESERVATION_DETAIL = 'Reservation detail',
  BIKE_DETAIL = 'Bike detail',
}
